import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import screenfull from "screenfull";
import { mapMutations } from "vuex";
export default {
  props: {
    isContainer: {
      type: Boolean,
      default: true
    }
  },
  name: "Screenfull",
  data: function data() {
    return {
      refEle: "",
      isFullscreen: false
    };
  },
  mounted: function mounted() {
    this.init();
    this.refEle = this.$options.parent.$el;
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setToggleTag: "settings/setToggleTag"
  })), {}, {
    click: function click() {
      console.log(screenfull, "111");
      if (!screenfull.enabled) {
        this.$message({
          message: "不支持全屏",
          type: "warning"
        });
        return false;
      }
      if (this.isContainer) {
        screenfull.toggle(this.refEle);
        this.setToggleTag(this.refEle);
        this.$emit("custom-event", this.isFullscreen);
      } else {
        screenfull.toggle();
        this.setToggleTag(null);
      }
    },
    change: function change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init: function init() {
      if (screenfull.enabled) {
        screenfull.on("change", this.change);
      }
    },
    destroy: function destroy() {
      if (screenfull.enabled) {
        screenfull.off("change", this.change);
      }
    }
  })
};